import { createSelector } from 'reselect';
import startingModulesListSelector from './startingModulesList';

export default (selector: () => string | undefined) =>
    createSelector(startingModulesListSelector, selector, (startingModulesList, code) =>
        startingModulesList.find((item) => item.code === code),
    );
